import {takeWhile, shareReplay, distinctUntilChanged, mergeMap, map} from 'rxjs/operators';
import {ChangeDetectorRef, Component, OnDestroy} from '@angular/core';
import {ResourceService} from '../../resource/resource.service';
import {CacheService} from '../../cache/cache.service';
import {Observable} from 'rxjs';
import {LayoutService} from '../../layout/layout.service';
import {LanguageService} from '../../language/language.service';
import {HomePageConfiguration} from '../../cache/uiconfiguration/homepageconfiguration';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../cache/currentuser/user';
import {Title} from '@angular/platform-browser';
import {APPCONFIG} from '../../config';

@Component({
  selector: 'my-dashboard',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnDestroy {
  languageResource: Observable<string>;
  homePageResouces: Observable<HomePageConfiguration[]>;
  administratorAccess: Observable<boolean>;
  currentUserID: string = null;

  constructor(
    private router: Router,
    private resourceService: ResourceService,
    private cacheService: CacheService,
    private layoutService: LayoutService,
    private languageService: LanguageService,
    private changeDetector: ChangeDetectorRef,
    private titleService: Title,
    private route: ActivatedRoute,
  ) {
    this.languageResource = this.cacheService.getLanguageResource();
    this.homePageResouces = this.cacheService.getHomePageConfigurations();
    this.administratorAccess = this.cacheService.getCurrentUser().pipe(
      map((usr: User) => usr.administrator),
      mergeMap(bool => bool),
      distinctUntilChanged(),
      shareReplay(1),
    );
    this.cacheService.getCurrentUser().subscribe((usr: User) => {
      this.currentUserID = usr.id;
    });
  }

  ngOnInit(): void {
    this.route.params.pipe(takeWhile(() => this._alive)).subscribe(params => {
      let id: string = params['id'];
      if (id == null) {
        this.homePageResouces = this.cacheService.getHomePageConfigurations();
      } else {
        this.homePageResouces = this.cacheService.getHomePageConfigurationsById(id);
      }
    });

    this.titleService.setTitle(APPCONFIG.pageTitle);
  }

  openHomePageItem(navBarItem: HomePageConfiguration) {
    let link = ['/home'];
    switch (navBarItem.sitetype) {
      case 'list':
      case 'olist':
      case 'create':
        link = ['/' + navBarItem.sitetype, navBarItem.urlid];
        break;
      case 'objectlist':
        link = ['/olist', navBarItem.urlid];
        break;
      case 'administration':
        link = ['/administration'];
        break;
      case 'get':
      case 'timeline':
        link = ['/' + navBarItem.sitetype, navBarItem.linkedobject];
        break;
      case 'profile':
        this.cacheService.getCurrentUser().subscribe(usr => {
          link = ['/get', usr.id];
          if (this.router.isActive(link.join('/'), true)) {
            this.layoutService.updateResourceView(navBarItem.sitetype, link[1], link[2]);
          } else {
            this.router.navigate(link);
          }
        });
        return;
      case 'wizard':
        link = ['/wizard', navBarItem.urlid, this.currentUserID];
        break;
      case 'external':
        window.location.href = navBarItem.urlid;
        return;
      case 'home':
        if (navBarItem.urlid == null) {
          link = ['/home'];
        } else {
          link = ['/home', navBarItem.urlid];
        }
        break;
      default:
        link = ['/home'];
    }

    if ((link.length === 2 || link.length === 3) && this.router.isActive(link.join('/'), true)) {
      this.layoutService.updateResourceView(navBarItem.sitetype, link[1], link[2]);
    } else {
      this.router.navigate(link);
    }
  }

  private _alive: boolean = true;

  ngOnDestroy(): void {
    this._alive = false;
  }
}
